import { create } from 'zustand';
import { Views } from './../enums/enums';
import settingsStore from './settings';

const initialState = {
  isSideBarOn: true,
  isSearchFiltersOn: true,
  isNewsOn: true,
  isMusicSearchFiltersOn: true,
  currentView: Views.Home,
  currentApp: "",
  isMobilePlayerVisible: false,
  safeArea: null,
  paddingBottoms: {},
  isLogoutFeedbackDialogShown: false,
  isUnsubscriptionDialogShown: true,
  isPopUpDialogShown: false,
  isMoveToExternalScreen: false,
  isPlayerFirstRender: true,
  isApiWindowPerm: false,
  isKeyboardOn: false,
  isBgPlayerInit: false,
  isAndroidSubMode: false,
  rightSideScroller: 0,
  externalViewBgIndex: 0,
  progChangeVolume: 0,
  isProgrammaticallyChanginVolume: false,
  isUserChangingVolume: true,
  programmaticVolumeCounter: 0
};

const navigationStore = create((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  plusProgChangeVolume:()=> {
    console.log("progChangeVolume +1")
    set({progChangeVolume: get().progChangeVolume+1})
  },
  minusProgChangeVolume:()=> {
    console.log("progChangeVolume -1")
    let progChangeVolume = get().progChangeVolume
    if(progChangeVolume > 0){
      set({progChangeVolume: get().progChangeVolume-1})
    }
  },
  setVolumeFlag: (isProgrammaticallyChanginVolume) => {
    console.log("setting volume flag", isProgrammaticallyChanginVolume)
    set({isProgrammaticallyChanginVolume:isProgrammaticallyChanginVolume})
  },
  setUserVolumeFlag: (isUserChanginVolume) => {
    set({isUserChanginVolume: isUserChanginVolume})
  },
  beginProgrammaticVolume: () => {
    const count = get().programmaticVolumeCounter + 1;
    set({
      programmaticVolumeCounter: count,
      isProgrammaticallyChangingVolume: true
    });
  },

  endProgrammaticVolume: () => {
    let count = get().programmaticVolumeCounter - 1;
    if (count < 0) count = 0; // safety

    set({
      programmaticVolumeCounter: count,
      isProgrammaticallyChangingVolume: count > 0
    })
  },
  rollExternalViewBgIndex: () => {
    let index = get().externalViewBgIndex;
    set({externalViewBgIndex: (index+1) % 5})
  },
  setRightSideScroller: (scroll) => {
    console.log("scroller t", scroll)
    set({rightSideScroller: scroll})
  },
  setAndroidSubMode: (isAndroidSubMode) => {
    set({isAndroidSubMode: isAndroidSubMode})
  },
  setBgPlayerInit: (isInit) => {
    set({isBgPlayerInit: isInit})
  },
  setIsKeyboardOn: (isVisible) => {
    set({isKeyboardOn: isVisible})
  },
  setLogoutFeedbackDialogShown: (isShown) => {
    set({ isLogoutFeedbackDialogShown: isShown });
  },
  setIsPlayerFirstRender: (isFirstRender) => {
    set({ isPlayerFirstRender: isFirstRender });
  },
  setUnsubscriptionDialogShown: (isShown) => {
    set({ isUnsubscriptionDialogShown: isShown });
  },
  setPopUpDialogShown: (isShown) => {
    set({ isPopUpDialogShown: isShown });
  },
  setSafeArea: (area) => {
    set({ safeArea: area });
  },
  setPaddingBottom: (id, padding) => {
    let paddingBottoms = get().paddingBottoms;
    paddingBottoms[id] = padding;
    set({ paddingBottoms: { ...paddingBottoms } });
  },
  setMobilePlayerVisible: (isVisible) => {
    set({ isMobilePlayerVisible: isVisible });
  },
  setCurrentApp: (app) => {
    set({ currentApp: app });
  },
  setNewsVisible:(isVisible) => {
    set({isNewsOn: isVisible})
  },
  toggleNews: () => set((state) => ({ isNewsOn: !state.isNewsOn })),
  toggleSearchFilters: () => set((state) => ({ isSearchFiltersOn: !state.isSearchFiltersOn })),
  toggleMusicSearchFilters: () => set((state) => ({ isMusicSearchFiltersOn: !state.isMusicSearchFiltersOn })),
  toggleSideBar: () => set((state) => ({ isSideBarOn: !state.isSideBarOn })),
  goToView: (view) => {
    if(view !== Views.Settings){
      settingsStore.getState().setSaveable(false);
      get().setPaddingBottom("muvika-settings", 0);
    }
    set((state) => ({ currentView: view, isMobilePlayerVisible: false }))
  }
}));

export default navigationStore;